import React, { useState } from "react";
import {
  IconButton,
  useTheme,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import {
  DeleteRounded,
  EditRounded,
  MoreVertRounded,
} from "@mui/icons-material";
import ConfirmationDialog from "../../../../../../../../components/ConfirmationDialog";
import EditUserDialog from "./EditUserDialog";

function MemberActionsMenu({
  user,
  edge,
  handleUpdateUser,
  handleDeleteUser,
  roles,
  handleSelectUser,
}) {
  const [action, setAction] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAction(null);
  };

  const handleClickChangeAccountStatus = () => {
    handleSelectUser(user);
    handleClose();
  };

  const handleClickAction = (action) => {
    setAction(action);
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        edge="end"
        sx={edge === "end" ? { marginRight: -1.5, marginTop: -0.5 } : {}}>
        <MoreVertRounded fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        // onClick={handleClose}
        autoFocus={false}
        disableAutoFocusItem
        slotProps={{ paper: { sx: { borderRadius: 2 } } }}>
        <MenuItem onClick={() => handleClickAction("edit_user")}>
          <ListItemIcon>
            <EditRounded />
          </ListItemIcon>
          <ListItemText>Edit User</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleClickChangeAccountStatus}>
          <ListItemIcon>
            <EditRounded />
          </ListItemIcon>
          <ListItemText>Change Account Status</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleClickAction("delete_user")}>
          <ListItemIcon>
            <DeleteRounded color="error" />
          </ListItemIcon>
          <ListItemText sx={{ color: "error.main" }}>Remove User</ListItemText>
        </MenuItem>
      </Menu>
      {action === "delete_user" && (
        <ConfirmationDialog
          onYes={() => handleDeleteUser(user.id)}
          onNo={handleClose}
          title={"Remove User"}
          content={"Are you sure you want to remove this user?"}
          yesLabel={"Remove"}
          noLabel={"Cancel"}
          isDelete={true}
        />
      )}
      {action === "edit_user" && (
        <EditUserDialog
          user={user}
          handleUpdateUser={handleUpdateUser}
          onClose={handleClose}
          roles={roles}
        />
      )}
    </>
  );
}

export default MemberActionsMenu;
